import React,{useEffect,useState} from 'react';
import './Header.css';
import lo from '../utils/lo.png'
import Searched from './Searched/Searched';
import cart from "../utils/Cart.svg"
import { Link } from 'react-router-dom';
import Cart from './cart/Cart';
import { useSelector } from 'react-redux';
import store from '../utils/store/store';
import { CartState } from '../../Context';
import { filterData } from '../utils/helper';
import SingleProduct from './cart/SingleProduct/SingleProduct';
const Header = () => {
    const[search,setSearch]=useState("");
    const [searchrest,setSearchrest]=useState([]);
    const [Fsearchrest,setFSearchrest]=useState([]);
    const [found,setFound]=useState(false);
     const [sd,setSd]=useState([]);
     const {
        state: { cart },
        dispatch,
      } = CartState();

      //console.log(cart)
     //IMP(2:28:30)
    // const cartItems=useSelector((store)=>store.cart.items);
    //  console.log(cartItems)
    useEffect(()=>{
        getRestaurants();
     },[]);

     async function getRestaurants(){
        const data=await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&sortBy=RELEVANCE&page_type=DESKTOP_WEB_LISTING");
        const json=await data.json();
       
        setSearchrest(json?.data?.cards[2]?.data?.data?.cards)
        setFSearchrest(json?.data?.cards[2]?.data?.data?.cards)
     }

        
        
     
     if (!searchrest) return null;
  return (
   
    <div className='Head'>
         
        <div className='Name'>TOMATO</div>
        <div className="Tab">
            <div className='Food'>
            <div className='FoodSearch'>
                <input style={{width:'25rem',height:"2.5rem",borderRadius:'1rem'}} placeholder="What's in your mood" value={search} onChange={(e)=>setSearch(e.target.value)}></input>
                {
                    <Link to={"/searched/"+search} element={<Searched/>} >
                    <button style={{borderRadius:"1rem",width:"5rem",height:'2.5rem'}} onClick={()=>{const data=filterData(search,searchrest); setFSearchrest(data);setFound(true)}}>Search</button>
                    </Link>
                }
            </div>
            </div>
        </div>
        
        <div style={{display:'flex',flexWrap:"wrap"}}>
        {found && Fsearchrest.map((restaurant) => {
          return (
            restaurant?.data?.id&&
            <Link
              to={"/single/" + restaurant?.data?.id}
              key={restaurant?.data?.id}
            >
              <SingleProduct {...restaurant.data} />
            </Link>
          );
          
       
        })}
        </div>
    </div>
  )
}

export default Header